import { connect } from "react-redux";

import VariableContainer from "./VariableContainer";
import { mapStateToProps } from "./VariableContainerMapper";

export default connect(mapStateToProps)(VariableContainer);
